// extracted by mini-css-extract-plugin
var _1 = "amex-cZotR";
var _2 = "carts-vK7yX";
var _3 = "discover-N9991";
var _4 = "mastercard-KCzKs";
var _5 = "paypal-iw9im";
var _6 = "visa-BdiVT";
export { _1 as "amex", _2 as "carts", _3 as "discover", _4 as "mastercard", _5 as "paypal", _6 as "visa" }
